import React from "react";
import { useNavigate } from "react-router-dom";
import { Progress as FBProgress } from "flowbite-react";

const Progress = ({ pageNum }) => {
  const navigate = useNavigate();

  const calculateProgress = () => {
    if (pageNum === 1) {
      return "33%";
    } else if (pageNum === 2) {
      return "67%";
    } else if (pageNum === 3) {
      return "100%";
    } else {
      return "0%";
    }
  };

  return (
    <div class="flex flex-1 justify-center items-center space-x-5 mt-20 mb-4">
      {/*} <button
        onClick={handleClickBack}
        class="text-xs font-bold uppercase rounded-md bg-lemongreen p-1 px-2 text-lemongray"
      >
        Back
  </button> */}
      <div class="flex flex-col">
        <div class="flex justify-between mb-1">
          <span class="text-xs md:text-sm font-bold font-karla text-lemongreen dark:text-white mr-3">
            Reservation Progress:
          </span>
          <span class="text-sm font-karla font-bold text-lemongreen dark:text-white">
            {pageNum} of 3{" "}
          </span>
        </div>
        <div>
          <FBProgress
            color="green"
            progress={pageNum * 33.3333}
            progressLabelPosition="inside"
            size="lg"
          />
        </div>
        <div class=" hidden w-full bg-lemondark rounded-full h-6 dark:bg-gray-700 text-xs md:text-sm">
          <div
            class="bg-lemonyellow h-6 rounded-full "
            style={{ width: calculateProgress() }}
          ></div>
        </div>
      </div>
      {/*
      <button
        onClick={handleClickNext}
        class="text-xs font-bold uppercase rounded-md bg-lemongreen p-1 px-2 text-lemongray"
      >
        Next
</button> */}
    </div>
  );
};

export default Progress;
